import { MatDialog } from "@angular/material/dialog";
import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChildren, } from "@angular/core";
import { DataSource } from "@angular/cdk/collections";
import { WarningComponent } from "src/app/shared/components/warning/warning.component";
import { BehaviorSubject, Observable, Subject, } from "rxjs";
import { NotificationService } from "src/app/core/services/notification.service";
import { CommonService } from "src/app/core/services/common.service";
import { NotifierService } from "angular-notifier";
import { BaseComponent } from "src/app/shared/components/base/base.component";

import { animate, state, style, transition, trigger, } from "@angular/animations";

import { map, startWith } from "rxjs/operators";
import { Message } from "src/app/core/class/message";
import { ActivatedRoute, Router } from "@angular/router";
import { FormControl, FormGroup } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { GeneralCategory } from "src/app/shared/models/general-category.model";
import { ErrorCode } from "src/app/core/constants/error-code";
import { LaborUtilizationReportService } from "src/app/core/services/labor-utilization-report.service";

interface IDocumentEnterprise{
  documentTemplateId: number | string | null;
  name: string;
  id: string;
  code: string;
  serviceType: string | number;
  isDraft: boolean;
  status: boolean;
}

interface IMergeFieldData{
  mergeField: any;
  isGroup?: boolean;
  startGroup?: string;
  endGroup?: string;
  children?: any;
}

@Component({
  selector: "app-list-labor-utilization-report",
  templateUrl: "./list-labor-utilization-report.component.html",
  styleUrls: ["./list-labor-utilization-report.component.scss"],
  animations: [
    trigger("detailExpand", [
      state(
        "void",
        style({ height: "0px", minHeight: "0", visibility: "hidden" })
      ),
      state("*", style({ height: "*", visibility: "visible" })),
      transition("void <=> *", animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")),
    ]),
  ],
})
export class ListLaborUtilizationReportComponent
  extends BaseComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren("focusInput") focusInput;

  @Output() changeTabSelected = new EventEmitter<any>()

  searchLaborReportForm: FormGroup;
  listDataSource: LaborUtilizationReportDataSource;

  displayedColumns = ["stt", "name", "code", "type", "status", "action"];

  category = {
    serviceType: "",
    nameOrCode: "",
    status: null,
    isDraft: null,
    page: 0,
    size: 10,
  };

  paginate = {
    currentPage: 0,
    pageSize: 10,
    totalRow: 0,
    totalPage: 0,
    totalPageArray: [],
    no: [],
  };

  listServiceType: any = [];

  listServiceTypeFilter: Observable<any>;

  searchServiceTypeCtrl: FormControl = new FormControl(null);
  loadingSearch: boolean = false;
  _onDestroy = new Subject<void>();

  constructor(
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService,
    private router: Router,
    public toast: ToastrService,
    public route: ActivatedRoute,
    private notificationService: NotificationService,
    private laborUtilizationReportService: LaborUtilizationReportService
  ) {
    super(commonService, message);
    this.notifier = notifier;
    this.route.queryParams.subscribe((queryparams) => {
      this.category = {
        serviceType: queryparams.serviceType ? queryparams.serviceType : null,
        nameOrCode: queryparams.nameOrCode ? queryparams.nameOrCode : null,
        status: queryparams.status ? queryparams.status : null,
        isDraft: queryparams.isDraft ? queryparams.isDraft : null,
        page: queryparams.page ? queryparams.page : 0,
        size: queryparams.size ? queryparams.size : 10,
      };
    });
  }

  ngOnInit() {
    let status = null;
    if (this.category.isDraft && JSON.parse(this.category.isDraft)) {
      status = 'DRAFT';
    } else if (this.category.status && JSON.parse(this.category.status) === false) {
      status = 'INACTIVE';
    } else if (this.category.status && JSON.parse(this.category.status) === true) {
      status = 'ACTIVE';
    }
    this.searchLaborReportForm = new FormGroup({
      serviceType: new FormControl(this.category.serviceType),
      nameOrCode: new FormControl(this.category.nameOrCode),
      statusEquals: new FormControl(status),
    });
    this.listDataSource = new LaborUtilizationReportDataSource();
    this.loadData(this.category);
    window.scrollTo(0, 0);
    this.notificationService.subscribeErrorService();
    this.getListServiceType();
    this.initFormControlSearch();
  }

  ngAfterViewInit() {
    setTimeout((_) => this.focusInput.first.nativeElement.focus());
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.notificationService.subscribeErrorService();
  }

  loadData(request: any) {
    this.laborUtilizationReportService.getLaborReport(request).subscribe((res) => {
      if (!res || !res.data) {
        return;
      }
      this.listDataSource.setData(res.data.content);
      this.paginate = {
        currentPage: res.data.pageable.page,
        pageSize: res.data.pageable.size,
        totalRow: res.data.total,
        totalPage: Math.ceil(res.data.total / res.data.pageable.size),
        totalPageArray: this.commonService.counter(
          Math.ceil(res.data.total / res.data.pageable.size),
          1
        ),
        no: this.commonService.counter(
          res.data.pageable.size,
          res.data.pageable.page * res.data.pageable.size + 1
        ),
      };
    });
  }

  /**
   * Filter data with condition
   */
  onClickBtnFilter() {
    const controls = this.searchLaborReportForm.controls;
    const temp = this.searchLaborReportForm.controls['statusEquals'].value;
    if (temp === 'DRAFT') {
      this.category.isDraft = true;
      this.category.status = null;
    } else if (temp === 'ACTIVE') {
      this.category.status = true;
      this.category.isDraft = false;
    } else if (temp === 'INACTIVE') {
      this.category.status = false;
      this.category.isDraft = false;
    } else {
      this.category.status = null;
      this.category.isDraft = null;
    }

    this.category.serviceType = controls.serviceType.value
      ? controls.serviceType.value
      : null;
    this.category.nameOrCode = controls.nameOrCode.value
      ? controls.nameOrCode.value
      : null;
    this.category.page = 0;
    this.category.size = 10;
    this.loadData(this.category)
  }

  clearData(field: string) {
    this.searchLaborReportForm.get(field).patchValue(null);
  }

  onPageChange(page: number = 0, pageSize: number = 10) {
    this.paginate = {
      ...this.paginate,
      currentPage: page,
      pageSize,
    };
    this.category.page = this.paginate.currentPage;
    this.category.size = this.paginate.pageSize;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        ...this.category,
        currentTab: 1
      },
      queryParamsHandling: "merge",
      replaceUrl: true,
      skipLocationChange: false,
    });
  }

  editCategory(id: string) {
    const link = `/home-enterprise/labor-utilization-report/update/${id}`;

    this.laborUtilizationReportService.getLaborReportById(id).subscribe(res => {
      if (!res || res.code === ErrorCode.MasterDataTypeNotFound) {
        this.toast.error(
          this.message.getMessage("messages.delete_labor_report_found_error")
        );
        this.router.navigateByUrl('/home-enterprise/labor-utilization-report');
      } else {
        this.router.navigateByUrl(link);
      }
    })
  }

  async deleteCategory(element) {
    const dataDialog = this.commonService.format(
      this.message.getMessage("messages.confirm_delete_labor_report"),
      element.name
    );
    const warnDialog = this.dialog.open(WarningComponent, {
      width: "40%",
      data: dataDialog,
    });
    warnDialog.afterClosed().subscribe(async (res) => {
      if (res) {
        this.laborUtilizationReportService
          .deleteLaborReport({id: element.id})
          .subscribe((res) => {
            if (res && res.code === ErrorCode.NotPermissionTemplate) {
              this.toast.error(this.message.getMessage('messages.check_permission'));
              return;
            }
            this.toast.success(
              this.message.getMessage(
                'messages.delete_labor_report_success'
              )
            );
            if (this.paginate.totalRow % this.paginate.pageSize === 1 && this.paginate.currentPage === this.paginate.totalPage - 1) {
              this.category.size = this.paginate.pageSize;
              this.category.page = this.paginate.currentPage ? this.paginate.currentPage - 1 : 0;
            }
            this.loadData(this.category);
          });
      }
    });
  }

  onClickCreateLaborReport() {
    this.router.navigateByUrl("/home-enterprise/labor-utilization-report/create");
  }

  initFormControlSearch() {
    this.listServiceTypeFilter = this.searchServiceTypeCtrl.valueChanges.pipe(
      startWith(""),
      map((value) => {
        if (!value) {
          return this.listServiceType;
        }
        return this.listServiceType.filter((st) => {
          const optionLabel = `${this.commonService.extractUnicode(st.name)}`;
          return optionLabel.toLowerCase().includes(this.commonService.extractUnicode(value).trim().toLowerCase());
        });
      })
    );
  }

  getListServiceType() {
    const enterpriseId = localStorage.getItem('enterpriseId');
    this.laborUtilizationReportService.getServiceTypes(enterpriseId).subscribe((res) => {
      const { data } = res;
      this.listServiceType = data;
      this.searchServiceTypeCtrl.patchValue("");
    });
  }

  focusOut(field: string) {
    const value = this.searchLaborReportForm.get(field).value
      ? this.searchLaborReportForm.get(field).value.trim()
      : null;
    this.searchLaborReportForm.get(field).patchValue(value);
  }

  displayTooltip(data, index, className) {
    const elmsSpan = document.getElementsByClassName(className);
    const elmsCell = document.getElementsByClassName("cell");

    if (elmsSpan.item(index).scrollWidth > elmsCell.item(index).scrollWidth) {
      return data;
    } else {
      return null;
    }
  }

  displayTooltipForDes(data, index, className) {
    const elmsSpan = document.getElementsByClassName(className);
    const elmsCellDes = document.getElementsByClassName("cellDes");

    if(elmsSpan.item(index) && elmsCellDes.item(index) && (elmsSpan.item(index).scrollWidth > elmsCellDes.item(index).scrollWidth)) {
      return data;
    } else {
      return null;
    }
  }
}

export class LaborUtilizationReportDataSource extends DataSource<GeneralCategory> {
  /** Stream of data that is provided to the table. */
  private data = new BehaviorSubject<GeneralCategory[]>([]);
  private loading = new BehaviorSubject<boolean>(false);

  public loading$ = this.loading.asObservable();

  constructor() {
    super();
  }

  // indicate is loading
  startLoadData() {
    this.loading.next(true);
  }

  setData(data: GeneralCategory[]) {
    /* this.data = new BehaviorSubject<ServiceType[]>(data); */
    this.data.next(data);
    this.loading.complete();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<GeneralCategory[]> {
    /* return this.data; */
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
    this.loading.complete();
  }
}